module.exports = __webpack_public_path__ + "static/img/banner_jian.0576ded.png";